import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { ActivatedRoute } from '@angular/router';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { Unidade } from 'src/app/model/unidade';
import { PedidoService } from 'src/app/dao/pedido.service';
import { GlobalService } from 'src/app/dao/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-configuracoes-frete',
  templateUrl: './configuracoes-frete.page.html',
  styleUrls: ['./configuracoes-frete.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ConfiguracoesFretePage implements OnInit {

  unidade: Unidade;
  plano;
  dominio;
  loja;
  timeStamp;
  minTempo = '00:00';
  dataRequired = false;
  mostrarHorarios = false;
  mostrarHorarios2 = false;
  listaJson;

  json='[   {      "ativo":0,      "dia":0,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Domingo"   },   {      "ativo":0,      "dia":1,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Segunda"   },   {      "ativo":0,      "dia":2,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Terça"   },   {      "ativo":0,      "dia":3,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Quarta"   },   {      "ativo":0,      "dia":4,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Quinta"   },   {      "ativo":0,      "dia":5,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Sexta"   },   {      "ativo":0,      "dia":6,      "horaInicio":"10",      "horaFim":"11",      "nomeDia":"Sábado"   }]';
  constructor(public alertController: AlertController, private http: HttpClient, public global: GlobalService, private route: ActivatedRoute, private toast: ToastService, private pedidoapi: PedidoService, private apiUnidade: UnidadeApiService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.unidade = new Unidade();
    // tslint:disable-next-line: radix
    this.loadUnidade();
    //this.montaOpcaodias();
    this.dominio = this.global.dominio;
    this.loja = this.global.loja;

    this.plano = this.global.plano;

  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }
  

  deletarJson() {
    console.log("Chamou a func");
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar as Configurações de Frete Grátis?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.listaJson = JSON.parse(this.json);
        this.unidade.json_frete_gratis = "";
        this.toast.showSucess('Configurações de Frete Grátis Limpas');
      }
    });
  }



  showHorarios(){
    this.mostrarHorarios = this.unidade.usar_horario;
  }


  showHorarios2(){
    this.mostrarHorarios2 = this.unidade.usar_horario_local;
  }

  async loadUnidade() {
    this.unidade = await this.apiUnidade.getAtual();

    try{
      this.listaJson = JSON.parse(this.unidade.json_frete_gratis);
      console.log("caiu no try");
      console.log(this.listaJson);
    }catch{
      this.listaJson = JSON.parse(this.json);
      console.log("caiu no catch");
      console.log(this.listaJson);


    this.unidade.tipos_entrega = this.unidade.tipos_entrega.toString();
    this.unidade.frete_fixo = this.unidade.frete_fixo.toString();
    this.mostrarHorarios = this.unidade.usar_horario;
    this.mostrarHorarios2 = this.unidade.usar_horario_local;

    }

    

  }

  setFreteGratis(valor) {
    this.dataRequired = valor;
  }

  aplicarJson(){
    //console.log(JSON.parse(this.unidade.json_frete_gratis));
    //console.log(this.listaJson);
    this.unidade.json_frete_gratis = JSON.stringify(this.listaJson);
    this.toast.showSucess('Configurações de Frete Grátis Diário Aplicadas');
  }






  async onSubmit() {

    // tslint:disable-next-line: radix
    if (parseInt(this.unidade.frete_gratis_inicio) >= parseInt(this.unidade.frete_gratis_fim)) {
      this.toast.showError('A data de início do frete grátis deve ser menor do que a do fim!');
    } else {

      for (var key in this.unidade) {
        if(this.unidade[key] === false){
          this.unidade[key] = 0;
        }
        if(this.unidade[key] === true){
          this.unidade[key] = 1;
        }
    }
      
      try {
        console.log(this.unidade);
        const result = await this.apiUnidade.atualizar(this.unidade);
        console.log(result);
        this.unidade.id = result.id;


        this.toast.showSucess('Salvo com sucesso');
      } catch (error) {
        console.log(error);
        this.toast.showError('Ocorreu um erro ao tentar salvar as Configurações');
      }

    }
  }
  
}
